<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="搜索关键字" name="keyword"></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="会员"
					width="150"
				>
					<template #default="{data}">
					    {{data.user_manage_mobilephone}}{{data.nick_name}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="联系人"
					name="contacts"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="联系邮箱"
					name="email"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="留言时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="留言内容"
					name="content"
					width="600"
				></c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_feedback',
		
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/feedback/list',
					data
				});
			}
		}
	}
</script>